module.exports = __webpack_public_path__ + "img/icons-2.3c74d90a.png";